import React, { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import './App.css';
import { getAuth } from 'firebase/auth';
import { firebaseConfig, db } from './firebase';
import Footer from './Footer';

firebase.initializeApp(firebaseConfig);

const TaskBar = () => {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState('');
  const [newTag, setNewTag] = useState('');
  const [newPriority, setNewPriority] = useState('Low');
  const [newNotes, setNewNotes] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [tagSearchTerm, setTagSearchTerm] = useState('');


  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        let tasks = [];
        
        if (user) {
          const snapshot = await db.collection('tasks')
            .where('deleted', '==', false)
            .where('userId', '==', user.uid)
            .get();
          tasks = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        } else {
          const storedTasks = sessionStorage.getItem('tasks');
          if (storedTasks) {
            tasks = JSON.parse(storedTasks);
          }
        }
        
        setTasks(tasks);
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchTasks();
  }, [db]);


  const handleAddTask = async () => {
    console.log('Adding task...');
    if (newTask.trim()) {
      const auth = getAuth();
      const user = auth.currentUser;
      const task = {
        name: newTask,
        tag: newTag,
        priority: newPriority,
        notes: newNotes,
        completed: false,
        deleted: false,
        userId: user ? user.uid : null, 
      };
      
      if (user) {
        try {
          const docRef = await db.collection('tasks').add(task);
          console.log('Task added successfully');
          setTasks(prevTasks => [...prevTasks, { id: docRef.id, ...task }]);
        } catch (error) {
          console.error('Error adding task:', error);
        }
      } else {
        const updatedTasks = [...tasks, task];
        setTasks(updatedTasks);
        sessionStorage.setItem('tasks', JSON.stringify(updatedTasks));
      }
      
      setNewTask('');
      setNewTag('');
      setNewPriority('Low');
      setNewNotes('');
    }
  };


  const deleteTask = async (index, taskId) => {
    const auth = getAuth();
    const user = auth.currentUser;
  
    if (user) {
      try {
        await db.collection('tasks').doc(taskId).set({ deleted: true }, { merge: true });
        console.log('Task marked as deleted successfully:', taskId);
      } catch (error) {
        console.error('Error marking task as deleted:', error);
      }
    }
  
    const updatedTasks = tasks.filter((_, i) => i !== index);
    setTasks(updatedTasks);
  
    if (!user) {
      sessionStorage.setItem('tasks', JSON.stringify(updatedTasks));
    }
  };
  
  
  const toggleComplete = async (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    
    try {
      await db.collection('tasks').doc(updatedTasks[index].id).update({ completed: updatedTasks[index].completed });
      console.log('Task marked as completed successfully:', updatedTasks[index].id);
    } catch (error) {
      console.error('Error marking task as completed:', error);
    }
  
    setTasks(updatedTasks);
  };
  
  const filteredTasks = tasks.filter(task =>
    task.name?.toLowerCase().includes(searchTerm.toLowerCase()) &&
    task.tag?.toLowerCase().includes(tagSearchTerm.toLowerCase())
  );

  const taskList = filteredTasks.map((task, index) => (
    <tr className="newInput" key={index}>
      <td className='checked'>
        <input
          type="checkbox"
          checked={task.completed}
          onChange={() => toggleComplete(index)}
        />
      </td>
      <td>{task.name}</td>
      <td>{task.tag}</td>
      <td>{task.priority}</td>
      <td className='notes'>{task.notes}</td>
      <td className='checked'>
        <button className='deleteBtn' onClick={() => deleteTask(index, task.id)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 50 59"
            className="bin"
          >
            <path
              fill="#B5BAC1"
              d="M0 7.5C0 5.01472 2.01472 3 4.5 3H45.5C47.9853 3 50 5.01472 50 7.5V7.5C50 8.32843 49.3284 9 48.5 9H1.5C0.671571 9 0 8.32843 0 7.5V7.5Z"
            ></path>
            <path
              fill="#B5BAC1"
              d="M17 3C17 1.34315 18.3431 0 20 0H29.3125C30.9694 0 32.3125 1.34315 32.3125 3V3H17V3Z"
            ></path>
            <path
              fill="#B5BAC1"
              d="M2.18565 18.0974C2.08466 15.821 3.903 13.9202 6.18172 13.9202H43.8189C46.0976 13.9202 47.916 15.821 47.815 18.0975L46.1699 55.1775C46.0751 57.3155 44.314 59.0002 42.1739 59.0002H7.8268C5.68661 59.0002 3.92559 57.3155 3.83073 55.1775L2.18565 18.0974ZM18.0003 49.5402C16.6196 49.5402 15.5003 48.4209 15.5003 47.0402V24.9602C15.5003 23.5795 16.6196 22.4602 18.0003 22.4602C19.381 22.4602 20.5003 23.5795 20.5003 24.9602V47.0402C20.5003 48.4209 19.381 49.5402 18.0003 49.5402ZM29.5003 47.0402C29.5003 48.4209 30.6196 49.5402 32.0003 49.5402C33.381 49.5402 34.5003 48.4209 34.5003 47.0402V24.9602C34.5003 23.5795 33.381 22.4602 32.0003 22.4602C30.6196 22.4602 29.5003 23.5795 29.5003 24.9602V47.0402Z"
              clipRule="evenodd"
              fillRule="evenodd"
            ></path>
            <path fill="#B5BAC1" d="M2 13H48L47.6742 21.28H2.32031L2 13Z"></path>
          </svg>
        </button>
      </td>
    </tr>
  ));
  

  return (
    <div className="taskBar">
      <div className='topBar'>
        <h1>Today's Task</h1>
      <div className='inputSearch'>
      <input
          type="text"
          placeholder="Search tasks"
          value={searchTerm}
          onChange={event => setSearchTerm(event.target.value)}/>
      <input
          type="text"
          placeholder="Search tags"
          value={tagSearchTerm}
          onChange={event => setTagSearchTerm(event.target.value)}/>
      </div>
      </div>
      <table className="center">
        <thead>
          <tr>
            <th className='checked'><span>&#10003;</span></th>
            <th>Task Name</th>
            <th>Tag</th>
            <th>Priority</th>
            <th className='notes'>Notes</th>
            <th className='checked'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {taskList}
          <tr className='inputBars'>
            <td></td>
            <td>
              <input
                type="text"
                placeholder="Enter task name"
                value={newTask}
                onChange={(event) => setNewTask(event.target.value)}
              />
            </td>
            <td>
              <input
                type="text"
                placeholder="Enter tag"
                value={newTag}
                onChange={(e) => setNewTag(e.target.value)}
              />
            </td>
            <td>
              <select
                value={newPriority}
                onChange={(e) => setNewPriority(e.target.value)}
              >
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
              </select>
            </td>
            <td className='notes'>
              <input
                type="text"
                placeholder="Enter notes"
                value={newNotes}
                onChange={(e) => setNewNotes(e.target.value)}
              />
            </td>
            <td className='checked'>
              <button className='tbButton' onClick={handleAddTask}>Add Task</button>
            </td>
          </tr>

        </tbody>
      </table>
      <footer>
      <Footer />
      </footer>
    </div>
  );
}

export default TaskBar;

